import { Moon, Sun } from 'lucide-react'
import { Button } from '@clouway/ui'
import { resolveTheme, useTheme } from './ThemeProvider'

function ModeToggle() {
  const { theme, setTheme } = useTheme()
  const current = resolveTheme(theme)
  const next = current === 'dark' ? 'light' : 'dark'

  return (
    <Button variant="ghost" size="icon" aria-label={`Switch to ${next} mode`} onClick={() => setTheme(next)}>
      {current === 'dark' ? <Moon /> : <Sun />}
    </Button>
  )
}

export default ModeToggle
